<template>
  <button class="nebButton"
    :class="[
      type,
      {
        disabled,
        icon: icon !== ''
      }
    ]"
    @click="onClick"
  >
    <neb-icon v-if="icon !== ''"
      :name="icon"
      height="20px"
      width="20px"
    ></neb-icon>

    <span>
      <slot></slot>
    </span>
  </button>
</template>

<script>
import NebIcon from '../../Icon'

export default {
  name: 'NebButton',

  components: {
    NebIcon
  },

  props: {
    type: {
      type: String,
      default: 'primary'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    captureClicks: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    onClick (e) {
      if (this.captureClicks) {
        e.preventDefault()
      }

      if (this.disabled) { return }

      this.$emit('click')
    }
  }
}
</script>

<style lang="scss">
@import '../../style.scss';

.nebButton {
  box-sizing: border-box;
  padding: 10px 25px;
  border-radius: 3px;
  border: none;
  transition: all 100ms;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  &.icon {
    padding-left: 7px;

    >span {
      padding-left: 7px;
    }
  }

  >span {
    font-size: 12px;
    font-family: $defaultFont;
    font-weight: 500;
  }

  &.disabled {
    cursor: not-allowed;
  }

  &.primary {
    background-color: $tiffany-blue;

    >span {
      color: $white;
    }

    svg {
      color: $white;
    }

    &:hover {
      background-color: $cool-blue;
    }

    &.disabled {
      background-color: $pale-blue;
    }
  }

  &.danger {
    background-color: $blush;

    >span {
      color: $white;
    }

    >svg {
      color: $white;
    }
  }

  &.secondary {
    background-color: $greyish;

    >span {
      color: $white;
    }

    svg {
      color: $white;
    }

    &:hover {
      background-color: $warm-grey;
    }

    &.disabled {
      background-color: $very-light-pink-two;
    }
  }

  &.tertiary {
    background-color: $white-six;
    border: solid 1px $white-three;

    >span {
      color: $slate-grey;
      font-weight: 400;
    }

    svg {
      color: $slate-grey;
    }

    &:hover {
      background-color: $white-three;
      border-color: $greyish;
    }

    &.disabled {
      border-color: $pinkish-grey;
      background-color: $white-four;

      >span {
        color: $pinkish-grey;
      }

      svg {
        color: $pinkish-grey;
      }
    }
  }

  &.ghost {
    background-color: transparent;
    border: solid 1px $tiffany-blue;

    >span {
      color: $tiffany-blue;
    }

    svg {
      color: $tiffany-blue;
    }

    &:hover {
      background-color: $ice-blue;
    }

    &.disabled {
      background-color: $white;
      border: solid 1px $pinkish-grey;

      >span {
        color: $pinkish-grey;
      }

      svg {
        color: $pinkish-grey;
      }
    }
  }

  &.text {
    border: none;
    background-color: transparent;
    padding: 0;

    > span {
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: $slate-grey;
    }

    &.disabled {
      >span {
        color: $pinkish-grey;
      }

      svg {
        color: $pinkish-grey;
      }
    }
  }

  &.textPrimary {
    border: none;
    background-color: transparent;
    padding: 0;
    > span {
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: $tiffany-blue;
    }
    &.disabled {
      >span {
        color: $pinkish-grey;
      }
      svg {
        color: $pinkish-grey;
      }
    }
  }
}
</style>
